export default "__VITE_ASSET__Dk_kS1yu__"